import { IHelpDefinition } from "../tenant-health.model";

export enum TenantStorageSiteType {
  Engage = 'engage',
  Teams = 'teams',
  Group = 'group',
  SharePoint = 'sharepoint'
}

export enum TenantStorageType {
  OneDrive = 'onedrive',
  SharePoint = 'sharepoint'
}
export interface ITenantStorageUsed extends ITenantStorageUsedStats {
  platforms: ITenantStorageUsedPlatform[];
}

export interface ITenantStorageUsedPlatform extends ITenantStorageUsedStats {
  type: TenantStorageType;
  free?: number;
  siteTypes?: ITenantStorageSiteTypeUsed[];
}

export interface ITenantStorageSiteTypeUsed extends ITenantStorageUsedStats {
  type: TenantStorageSiteType;
  label?: string;
  color?: string;
  percentageUsed?: number;
}

export interface ITenantStorageUsedStats {
  total?: number;
  used?: number;

  totalConverted?: string;
  leftConverted?: number;
  leftConvertedUnit?: string;
  usedConverted?: string;
  percentageUsed?: number;
}



export interface ITenantStorageUsedExtraInfo extends ITenantStorageUsed {
  percentageUsed?: number;
}

export interface ITenantStorageUsedPlatformExtraInfo extends ITenantStorageUsedPlatform {
  label?: string;
  percentageUsed?: number;
  color?: string;
}


export const TENANTSTORAGEUSEDTYPESINFO: { [platform in TenantStorageSiteType]: { label: string; order: number, color: string; }; } =
{
  [TenantStorageSiteType.Engage]: { label: 'Engage', order: 1, color: "#2E89EB" },
  [TenantStorageSiteType.Teams]: { label: 'Teams', order: 2, color: "#525ABF" },
  [TenantStorageSiteType.Group]: { label: 'Groups', order: 3, color: "#50B392" },
  [TenantStorageSiteType.SharePoint]: { label: 'Sites', order: 4, color: "#8EEC79" }
}

export const sharepointHelpText: IHelpDefinition = {
  text: `<ul>
            <li>
              <strong> SharePoint Total Storage:</strong> total storage assigned for SharePoint, calculated as 1TB baseline plus 10GB per licensed user.
            </li>
            <li>
              <strong> SharePoint Free Storage:</strong> free SharePoint storage capacity, as indicated in SharePoint Admin Center.
            </li>
            <li>
              <strong> SharePoint Used Storage:</strong> storage used as indicated in SharePoint Admin Center.
            </li>
          </ul>`,
  autoClose: true,
};

export const oneDriveHelpText: IHelpDefinition = {
  text: `<ul>
            <li>
              <strong>OneDrive:</strong> total storage allocated across all licensed users, based on Microsoft 365 plan. By default, 1 TB per user is considered.
          </ul>`,
  autoClose: true,
};

export const storageHelpText: IHelpDefinition = {
  text: `<ul>
            <li>
              <strong>Total Storage:</strong> sum of storage capacity for SharePoint and OneDrive. Excludes Exchange, Power BI datasets, Stream (Classic) and Microsoft Dataverse for Teams/Power Platform.
            </li>
          </ul>`,
  autoClose: true,
}

export const sharepointTypesHelpText: IHelpDefinition = {
  text: `<ul>
            <li>
              <ul class="list-disc pl-16px">
                <li>
                  <strong>SharePoint:</strong> communication and team site with no group
                </li>
                <li>
                  <strong>Group:</strong> team site without Teams or Engage
                </li>
                <li>
                  <strong>Teams:</strong> linked to a Microsoft Team
                </li>
                <li>
                  <strong>Engage:</strong> linked to an Engage community
                </li>
              </ul>
            </li>
          </ul>`,
  autoClose: true,
}

// Channel Sites info to include on the Tooltip in the future
// <li>
//   <strong>Channel Sites: </strong> private and shared channel sites, not considered a standalone workspace
// </li>